import script from "./WorkflowAggregatesGithub.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowAggregatesGithub.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowAggregatesGithub.vue?vue&type=style&index=0&id=5245ff92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5245ff92"]])

export default __exports__